import { __assign, __awaiter, __generator } from "tslib";
import { getLegacyBaseDriverFromWrapper } from '../../../common/base-driver';
import { DeprecatedSelect } from './select';
import { renderAndMountComponent } from '@wix/answers-lib';
import { Simulate } from 'react-dom/test-utils';
import * as React from 'react';
export var createSelectLegacyDriver = function (element) {
    var baseDriver = getLegacyBaseDriverFromWrapper(element, '.select', DeprecatedSelect.name);
    var selectInput = baseDriver.find('.Select-input input');
    var openSelection = function () { return Simulate.focus(selectInput.elem); };
    var optionAtIndex = function (index) { return baseDriver
        .findAll('.Select-option')
        .get(index); };
    return {
        openSelection: function () { return openSelection(); },
        selectAtIndex: function (index) {
            openSelection();
            var elem = optionAtIndex(index).elem;
            Simulate.mouseDown(elem);
        },
        getSelectionTitles: function () {
            openSelection();
            return baseDriver.findAll('.Select-option').map(function (e) { return e.getText(); });
        },
        selectByOptionClassName: function (className) {
            openSelection();
            var elem = baseDriver.find(".Select-option." + className).elem;
            Simulate.mouseDown(elem);
        },
        selectOptionsBySelector: function (sel) { return __awaiter(void 0, void 0, void 0, function () {
            var selector, elem;
            return __generator(this, function (_a) {
                openSelection();
                selector = '.Select-option';
                elem = baseDriver.find(selector + " " + sel).elem;
                Simulate.mouseDown(elem);
                return [2 /*return*/];
            });
        }); },
        getSelectedValue: function () {
            var selector = '.Select-value';
            return baseDriver.isChildVisible(selector) ? baseDriver.find(selector).getText() : '';
        },
        getPlaceholder: function () {
            return baseDriver.find('.Select-placeholder').getText();
        },
        enterText: function (val) { return selectInput.enterValue(val); },
        hasClass: function (className) { return baseDriver.hasClass(className); },
    };
};
export var createSelect = function (props) {
    var elem = renderAndMountComponent(React.createElement(DeprecatedSelect, __assign({}, props)));
    return createSelectLegacyDriver(elem);
};
//# sourceMappingURL=select.legacy-driver.js.map